<div class="w-full max-w-7xl items-center lg:grid lg:grid-cols-2 lg:gap-10">
  <!-- Left section -->
  <section class="mb-8 text-white lg:mb-0">
    <h1
      class="font-montserrat text-3xl font-light lg:text-5xl lg:leading-[56px]"
    >
      Nitel is now part of
      <br />
      Comcast Business
    </h1>

    <p
      class="mt-4 max-w-xl font-lato text-sm font-normal text-white lg:text-base"
    >
      Our broad portfolio accommodates a range of needs — from turnkey to
      complex solution suites — for businesses of all sizes.
    </p>

    <a
      href="https://business.comcast.com/enterprise"
      target="_blank"
      title="Learn more about Comcast Business"
      class="tertiary-button"
    >
      LEARN MORE
    </a>
  </section>

  <!-- Right login card -->
  <section class="flex lg:justify-end">
    <div
      class="w-full max-w-xl rounded-xl bg-white p-8 text-black shadow-lg md:p-10"
    >
      <!-- Comcast Business | Nitel Logo -->
      <div class="mb-4 flex md:justify-center">
        <a routerLink="/" class="inline-block" title="Go to homepage">
          <img
            src="assets/images/logos/CB_Logo_Color_RGB.svg"
            alt="Comcast Business"
            class="h-10 w-auto md:h-14"
          />
        </a>
      </div>

      <div class="mx-auto mt-4 flex flex-col items-center justify-center">
        @if (passwordChanged) {
          <app-banner-message
            [message]="messages.passwordChanged"
            status="success"
          ></app-banner-message>
        } @else if (sessionExpired) {
          <app-banner-message
            [message]="messages.sessionExpired"
          ></app-banner-message>
        } @else if (loggedOut) {
          <app-banner-message
            [message]="messages.loggedOut"
            status="success"
          ></app-banner-message>
        } @else if (showRegistrationMessage) {
          <app-banner-message
            [message]="messages.registration"
            status="success"
          ></app-banner-message>
        }
      </div>

      <!-- Title -->
      <h2 class="comcast-h2">Sign in</h2>

      <!-- Step 1: Username Input -->
      @if (currentStep === 'username') {
        <form
          [formGroup]="usernameFormGroup"
          (ngSubmit)="checkLoginProvider()"
          class="mt-4"
          novalidate
        >
          <label for="username" class="comcast-input-label"> Username </label>
          <input
            formControlName="username"
            id="usernameId"
            type="text"
            required
            name="username"
            autocomplete="username"
            [attr.aria-invalid]="messages.usernameInput.length > 0"
            [ngClass]="{
              'comcast-input-invalid': messages.usernameInput.length > 0,
            }"
            class="comcast-input"
            placeholder="Enter your username"
          />
          <div
            class="comcast-validation-error"
            [ngClass]="{ hidden: messages.usernameInput.length < 1 }"
          >
            {{ messages.usernameInput }}
          </div>

          <div class="mt-6 flex">
            <button type="submit" class="btn-primary">
              @if (isLoading) {
                <div class="flex min-w-12 justify-center">
                  <mat-spinner [diameter]="20"></mat-spinner>
                </div>
              } @else {
                Next
                <mat-icon
                  class="flex !h-[18px] !align-middle !text-[18px] !leading-none"
                  >arrow_forward</mat-icon
                >
              }
            </button>
          </div>
        </form>
      } @else if (currentStep === 'password') {
        <!-- Step 2: Password Input -->
        <form
          [formGroup]="loginFormGroup"
          class="mt-4"
          novalidate
          (ngSubmit)="login()"
        >
          <label for="username" class="comcast-input-label">Username</label>

          <input
            formControlName="username"
            id="usernameId"
            type="text"
            required
            name="username"
            autocomplete="username"
            [attr.aria-invalid]="messages.usernameInput.length > 0"
            [ngClass]="{
              'comcast-input-invalid': messages.usernameInput.length > 0,
            }"
            class="comcast-input"
            placeholder="Enter your username"
          />

          <div
            class="comcast-validation-error"
            [ngClass]="{ hidden: messages.usernameInput.length < 1 }"
          >
            {{ messages.usernameInput }}
          </div>

          <label for="username" class="comcast-input-label mt-4"
            >Password</label
          >
          <input
            formControlName="password"
            id="passwordId"
            class="form-control"
            type="password"
            placeholder="Enter your password"
            required
            name="password"
            autocomplete="password"
            [attr.aria-invalid]="messages.passwordInput.length > 0"
            [ngClass]="{
              'comcast-input-invalid': messages.passwordInput.length > 0,
            }"
            class="comcast-input"
          />
          <div
            class="comcast-validation-error"
            [ngClass]="{ hidden: messages.passwordInput.length < 1 }"
          >
            {{ messages.passwordInput }}
          </div>

          <div class="mb-8 mt-4 flex justify-end md:mb-0 md:mt-1">
            <a
              [routerLink]="'/forgot-password'"
              [queryParams]="{
                username: loginFormGroup.get('username')?.value,
              }"
              class="comcast-blue-link font-bold"
              title="Forgot your password?"
            >
              Forgot your password?
            </a>
          </div>

          @if (errorMessage) {
            <div class="comcast-validation-error">
              {{ errorMessage }}
            </div>
          }

          <div class="mt-2 flex gap-4">
            <button
              (click)="goBack()"
              type="button"
              class="btn-secondary"
              [disabled]="isLoading"
            >
              <mat-icon
                class="flex !h-[18px] !align-middle !text-[18px] !leading-none"
                >arrow_back</mat-icon
              >
              Back
            </button>
            <button type="submit" class="btn-primary">
              @if (isLoading) {
                <div class="flex min-w-12 justify-center">
                  <mat-spinner [diameter]="20"></mat-spinner>
                </div>
              } @else {
                Login
              }
            </button>
          </div>

          <div class="mx-auto mt-8 flex items-center justify-center md:mt-4">
            <app-toggle
              formControlName="toggle"
              label="Keep me logged in"
              size="md"
              color="primary"
            >
            </app-toggle>
          </div>
        </form>
      }
    </div>
  </section>
</div>
